import React from 'react'
import { graphql } from 'gatsby'
import { Content } from '@components'
import Img from 'gatsby-image'
import {
  CircularProgressbarWithChildren,
  buildStyles
} from 'react-circular-progressbar'
import 'react-circular-progressbar/dist/styles.css'
import ProgressProvider from '@helpers/progressProvider'
import style from './goal-counter.mod.scss'

const GoalCounter = ({
  heading,
  leadNode,
  image,
  percentage,
  counterLabelNode: {
    childMarkdownRemark: { html }
  }
}) => {
  return (
    <div className={style.goal}>
      <h2>{heading}</h2>
      {leadNode?.childMarkdownRemark?.html && (
        <Content contentNode={leadNode} />
      )}
      <div className={style.goal__wrap}>
        <Img fluid={image.fluid} />
        <div className={style.goal__counter}>
          <ProgressProvider valueStart={0} valueEnd={percentage}>
            {value => (
              <CircularProgressbarWithChildren
                value={value}
                background
                backgroundPadding={-5}
                styles={buildStyles({
                  trailColor: 'transparent',
                  pathTransitionDuration: 1.5
                })}
              >
                <h3>{`${value}%`}</h3>
                <div dangerouslySetInnerHTML={{ __html: html }}></div>
              </CircularProgressbarWithChildren>
            )}
          </ProgressProvider>
        </div>
      </div>
    </div>
  )
}

export default GoalCounter
export const query = graphql`
  fragment GoalCounter on DatoCmsGoalCounter {
    id
    heading
    leadNode {
      childMarkdownRemark {
        html
      }
    }
    percentage
    moduleStyle
    padding
    background
    backgroundStyle
    counterLabelNode {
      childMarkdownRemark {
        html
      }
    }
    model {
      apiKey
    }
    image {
      fluid(maxWidth: 970, imgixParams: { fit: "crop", w: "970", h: "545" }) {
        ...GatsbyDatoCmsFluid
      }
    }
  }
`
